<template>
    <div class="hero-logged-golearn -wrap">
        <template>
            <TotemIntro type="video" v-on:on-play-video="openVideoModal()">
                <template #title>
                    <span v-html="getHeroTitle"></span>
                </template>
                <template #description>
                    <span v-html="$t('HeroGoLearn.logged_description')"></span>
                </template>
                <template #video>
                    <img :src="require('@/assets/images/hero/video-screen-non-logged-' + $totemLang + '.png')" alt="" class="intro__video-thumbnail" @click="openVideoModal"/>
                </template>
            </TotemIntro>
            <HeroVideoModal :videoSrc="videoSrc" />
        </template>
    </div>
</template>

<script>
    import HeroVideoModal from '@/components/landingpage/hero/HeroVideoModal'
    import { heroDataHelper } from 'components/landingpage/hero/heroDataHelper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'hero-logged-golearn',
        components: { HeroVideoModal },
        mixins: [heroDataHelper],
        computed: {
            ...mapGetters({
                currentUser: 'User/getCurrentUser'
            }),
            getHeroTitle () {
                return this.$t('HeroGoLearn.logged_title', { userName: this.currentUser.firstName })
            },
            videoSrc () {
                return 'https://player.vimeo.com/video/412102747?h=fe66b84773'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .hero-logged-golearn {

        [class="mobile_md"] &,
        [class*="mobile_sm"] & {
            margin: 20px 0 0;
        }
    }
</style>
